// eslint-disable-next-line no-restricted-imports

import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { borders } from '@99designs/emu/settings';
import DesignerMetaHeader from './DesignerMetaHeader';
import ExpandableText from './ExpandableText';
import StatsTable, { Stat as StatComponent } from './StatsTable';

export enum Stat {
    Responsiveness,
    ProjectCount,
    RepeatClients,
}

interface DesignerMetaProps {
    designer: {
        id: string;
        displayName: string;
        profile: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            lastSeenAt: any;
            isAvailable: boolean;
            utcOffset: string;
            completedProjectsCount: number;
            repeatCount: number;
            responsivenessScore: number;
            biography: string;
        };
    };
    pitch?: string;
    onClickDescription?: () => void;
    showFullText?: boolean;
    stats?: Stat[];
    spokenLanguage?: string;
    linkToProfile?: boolean;
}

const Header = styled.div`
    border-bottom: ${borders.content};
`;

const DesignerMeta = ({
    designer,
    pitch,
    onClickDescription,
    showFullText = false,
    stats = [],
    spokenLanguage,
    linkToProfile = false,
}: DesignerMetaProps) => {
    const showStats = stats.length > 0;

    const text = pitch || designer.profile.biography;
    return (
        <Box display="flex" flexDirection="column">
            <Header>
                <DesignerMetaHeader
                    designer={designer}
                    paragraphSize={'small'}
                    avatarSize={'extra-small'}
                    spokenLanguage={spokenLanguage}
                    linkToProfile={linkToProfile}
                />
            </Header>

            {showStats && (
                <StatsTable>
                    {/* eslint-disable-next-line array-callback-return */}
                    {stats.map((type) => {
                        switch (type) {
                            case Stat.RepeatClients:
                                return (
                                    <StatComponent
                                        amount={designer.profile.repeatCount}
                                        label={__('Repeat clients')}
                                        key={'repeat-' + designer.id}
                                    />
                                );
                            case Stat.ProjectCount:
                                return (
                                    <StatComponent
                                        amount={designer.profile.completedProjectsCount}
                                        label={__('Projects')}
                                        key={'projects-' + designer.id}
                                    />
                                );
                            case Stat.Responsiveness:
                                return (
                                    <StatComponent
                                        amount={`${designer.profile.responsivenessScore}%`}
                                        label={__('Responds within 24 hours')}
                                        key={'responsiveness-' + designer.id}
                                    />
                                );
                        }
                    })}
                </StatsTable>
            )}

            <Box marginTop={showStats ? '0.5bu' : '1bu'}>
                {designer.profile.biography.length > 0 && (
                    <ExpandableText
                        onExpand={onClickDescription}
                        text={text}
                        isExpanded={showFullText}
                        expandLabel={__('Full description')}
                    />
                )}
            </Box>
        </Box>
    );
};

export default DesignerMeta;
